module.exports = __webpack_public_path__ + "static/media/Zasady2.576f483d.jpg";